/**
 * Extract pathname from full URL if provided
 * Converts full URLs (https://example.com/path) to relative paths (/path)
 * to enable CSR navigation with Next.js Link or similar components
 *
 * @param href - The URL or path
 * @returns The pathname without origin (includes pathname + search + hash)
 *
 * @example
 * extractPathname('https://example.com/products/item-1?color=blue')
 * // returns: '/products/item-1?color=blue'
 *
 * @example
 * extractPathname('/products/item-1')
 * // returns: '/products/item-1'
 */
export const extractPathname = (href: string): string => {
  try {
    // Check if it's a full URL with protocol
    if (/^https?:\/\//i.test(href)) {
      const url = new URL(href);
      return url.pathname + url.search + url.hash;
    }
    return href;
  } catch {
    // If URL parsing fails, return as is
    return href;
  }
};

